export enum PlatformObjectTypeEnum {

    PollingServer = 0,
    ManualEntry = 1,
    RPI = 2
    // this will grow as we devlop more
}
